import { AsH3, ParagraphLG, TitleLG } from '@/atoms/Text'
import { useBeforeYouLeave } from '@/contexts/BeforeYouLeaveContext'
import { Submit } from '@/molecules/Action'
import { AngelDialog } from '@/molecules/AngelDialog'

export const BeforeYouLeaveModal = () => {
  const { body, header, showModal, onContinue, onStay, continueLabel, stayLabel } = useBeforeYouLeave()

  return showModal ? (
    <AngelDialog
      isDarkMode={false}
      className="w-3/4 text-black"
      bodyClassName="max-w-sm"
      onClose={onStay}
      open={showModal}
    >
      {header && (
        <TitleLG as={AsH3} weight="bold">
          {header}
        </TitleLG>
      )}
      <ParagraphLG color="black" className="mb-12 text-center md:my-8">
        {body}
      </ParagraphLG>
      <Submit
        className="flex-wrap *:text-nowrap"
        labelSubmit={continueLabel}
        labelCancel={stayLabel}
        onCancel={onStay}
        onSubmit={onContinue}
      />
    </AngelDialog>
  ) : null
}
